import { React, useState } from "react";
import "../NavBar/Navbar.css";
import { useSelector, useDispatch } from "react-redux";
import { sidebarReducer } from "../../Redux/store";
import { loginReducer } from "../../Redux/store";
import { AccessTockenReducer } from "../../Redux/store";
import Userlogo from "../../images/user.svg"
// import { useState } from "react";
// import { Container, Button, Menu, MenuItem } from "@mui/material";
import { useNavigate } from 'react-router-dom';
import arrowdown from "../../images/arrowdown.svg";
import { useEffect } from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
// import { useMsal } from "@azure/msal-react";

// import Button from 'react-bootstrap/Button';
// import Modal from 'react-bootstrap/Modal';

import SearchBarComponent from "../searchBar/searchBarComponent";

const Navbar = (props) => {
  const string = useSelector((state) => state.sidebar.string);
  const [show, setShow] = useState(false);
  const [toastShown, setToastShown] = useState(false); 
  const token = useSelector((state) => state.AccessTocken.accessTocken);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const handleClose = () => setShow(false);
  const ShowRecord = () => {
    navigate('/resetPassword');
  };

  
  const isLogin = useSelector((state) => state.Login.isLogin);


  useEffect(() => {
    const checkTokenExpiry = () => {
      const currentTime = new Date();
      const userData = JSON.parse(sessionStorage.getItem("userdata"));
      const tokenExpiresAtUTC = new Date(userData.tokenExpiresAt);
      const offsetInMinutes = new Date().getTimezoneOffset();
      const offsetMilliseconds = offsetInMinutes * 60 * 1000;
  
      // Adjust expiration time with the offset
      const tokenExpiresAt = new Date(tokenExpiresAtUTC.getTime() - offsetMilliseconds);
      
      
      if (currentTime >= tokenExpiresAt) {
        console.log("Token Expired. Logging out...",tokenExpiresAt);
        dispatch(loginReducer.Logout());
        dispatch(AccessTockenReducer.accessTocken(""));
        dispatch(AccessTockenReducer.refreshTocken(""));
        sessionStorage.clear();
        navigate('/login');
      } else {
        // console.log("Token is still valid.");
        // console.log("Token is still valid.",tokenExpiresAt);
      }
    };

    const intervalId = setInterval(checkTokenExpiry, 1000);

    return () => clearInterval(intervalId);
  },[]);


  


  useEffect(() => {
    const userData = JSON.parse(sessionStorage.getItem("userdata"));
    const tokenExpiresAtUTC = new Date(userData.tokenExpiresAt);
    const offsetInMinutes = new Date().getTimezoneOffset();
    const offsetMilliseconds = offsetInMinutes * 60 * 1000;
  
    // Adjust expiration time with the offset
    const targetTime = new Date(tokenExpiresAtUTC.getTime() - offsetMilliseconds);
    // const targetTime = new Date(JSON.parse(sessionStorage.getItem("userdata")).tokenExpiresAt);  

    const checkTime = () => {
      const currentTime = new Date();
   
      if (currentTime.getHours() === targetTime.getHours() &&
          currentTime.getMinutes() === targetTime.getMinutes() &&
          currentTime.getSeconds() === targetTime.getSeconds() &&
          currentTime.getFullYear() === targetTime.getFullYear() &&
          currentTime.getMonth() === targetTime.getMonth() &&
          currentTime.getDate() === targetTime.getDate() 

        ) {
      
        yourFunction();
      }
    };

    const intervalId = setInterval(checkTime, 1000); 

    return () => {
      clearInterval(intervalId); 
    };
  }, []);


  useEffect(() => {
    const userData = JSON.parse(sessionStorage.getItem("userdata"));
    const tokenExpiresAtUTC = new Date(userData.tokenExpiresAt);
    const offsetInMinutes = new Date().getTimezoneOffset();
    const offsetMilliseconds = offsetInMinutes * 60 * 1000;
  
    // Adjust expiration time with the offset
    const targetTime = new Date(tokenExpiresAtUTC.getTime() - offsetMilliseconds);
    const currentTime = new Date();
    const timeRemaining = targetTime.getTime() - currentTime.getTime();
  
    if (timeRemaining > 0) {
      const warningTime = 30 * 1000;
      const warningTimeout = timeRemaining - warningTime;
  
      const intervalId = setInterval(() => {
        const currentTime = new Date();
        const timeRemaining = targetTime.getTime() - currentTime.getTime();
  
        if (timeRemaining == warningTime && !toastShown) {
          toast.warn('Session is about to expire', {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          setToastShown(true);
        }
  
        if (timeRemaining <= 0) {
          clearInterval(intervalId);
          yourFunction();
        }
      }, 1000);
  
      return () => {
        clearInterval(intervalId);
      };
    }
  }, []);
  

  const yourFunction = () => {
    
    sessionStorage.clear();
    navigate('/login');
  };

  const logoutHandler = async (e) => {
  
    e.preventDefault();
    const userdata = sessionStorage.getItem("userdata");
    const userDataObject = JSON.parse(userdata);
    const username = userDataObject.te_username;
    
    if (token) {
      const response = await axios.post(
        "/v1/auth/logout",
        {
          username: username
        },
        {
          headers: {
            'Authorization': 'Bearer' + ' ' + sessionStorage.getItem("access_token"),
          }
        }
      );
      if (response.status === 200) {
        dispatch(loginReducer.Logout());
        dispatch(AccessTockenReducer.accessTocken(""));
        dispatch(AccessTockenReducer.refreshTocken(""));
        sessionStorage.clear();
        navigate('/login');
      }
    } else {
    }
  };
 

  return (
    <header style={{ zIndex: "-1" }}>
      <AppBar>
        <Toolbar className="header-section-div firstrow">
          <SearchBarComponent />
          <div className="user-details-username">
            <img
              className="p-1"
              src={Userlogo}
              alt="user"
              style={{
                width: "36px",
                height: "36px",
                marginRight:"10px"
              }}
            />
           {JSON.parse(sessionStorage.getItem("userdata")).te_username}
          </div>
          <div className="d-flex flex-row-reverse">
            <div className="p-2">
              <div className="dropstart pt-1">
                <a
                  className="nav-link dropdown-toggle"
                  href="ntng"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <img
                    className="p-1"
                    src={arrowdown}
                    alt="user"
                  />
                </a>
                <ul className="dropdown-menu dropmenu position-absolute">
                  <li>
                    <p className="dropdown-item" onClick={ShowRecord}>
                      <span style={{ cursor: "pointer" }}>
                        <i className="bi bi-sliders px-2"></i>Reset Password
                      </span>
                    </p>
                  </li>
                  <li>
                    <form onSubmit={logoutHandler}>
                      <button className="dropdown-item" href="/">
                        <i className="bi bi-box-arrow-left px-2"></i>
                        {/* onClick=
                          {() =>
                            instance.logoutPopup({
                              postLogoutRedirectUri: "/",
                              mainWindowRedirectUri: "/",
                            })
                          } */}
                        Log Out
                      </button>
                    </form>
                  </li>
                  {/* <li>
                      <button
                        variant="warning"
                        className="ml-auto"
                        onClick={() =>
                          instance.logoutRedirect({
                            postLogoutRedirectUri: "/",
                          })
                        }
                      >
                        SignOut Popup
                      </button>
                    </li> */}
                </ul>
              </div>
            </div>
            {/* <div className="py-3 px-2 border-light text-white border-start border-opacity-25">
              <h4>{userName}</h4>
            </div> */}
          </div>
          {/* <Container>
             <Button className="userprofile" onClick={onClick}>Hello</Button>
                <Menu anchorEl={anchor} open={!!anchor}>
                   <MenuItem onClick={onClose}>Foo</MenuItem>
                </Menu>
          </Container>  */}
          {/* <Button className="logoutbtn" onClick = {logoutHandler}>
             <img 
              src={require("../../images/logout.png")}
              style={{ paddingRight:"4px"}}
              alt="logout"
            />
              Logout</Button> */}
        </Toolbar>
        {/* <Toolbar className="secondrow">
       {
         string === "onboardedclient" &&
            <Button className="onboardbtn" onClick={() => setShow(true)}> Onboard Client</Button>
       }
    </Toolbar> */}
      </AppBar>
      {/* {show &&
      <PopupModal show={show} handleClose={handleClose} />
    } */}
    </header>
  );
};

export default Navbar;
